import React from 'react';

import { Select, Button } from '@cimpress/react-components';
import { useDispatch } from 'react-redux';
import { manifestSingleActor } from '../../store/actions/manifest';
import { Options, Option } from '../../models/utils';
import { ValueType } from 'react-select';
import { valueToArray } from '../../utils/functions';
import { FlexBox, FlexGrow } from '../../utils/css-classes';

export interface ManifestActionsProps {
  manifestId: string;
  onSubmit: () => void;
}

const manifestActors: Options = [
  { value: 'TruckCarrierManifestActor', label: 'Carrier manifest actor' },
  { value: 'TruckBorderManifestActor', label: 'Border manifest actor' },
  { value: 'TruckBrokerManifestActor', label: 'Broker manifest actor' },
  { value: 'TruckBrokerV2ManifestActor', label: 'Broker manifest actor (v2)' },
];

// tslint:disable-next-line:function-name
export function RunManifestActor({ manifestId, onSubmit }: ManifestActionsProps) {
  const [actorName, setActorName] = React.useState<ValueType<Option>>(null);

  const dispatch = useDispatch();

  function submitManifestSingleActor() {
    const value = valueToArray(actorName);
    if (value && value[0]) {
      dispatch(manifestSingleActor.request({ manifestId, actorName: value[0].value as any }));
      onSubmit();
    }
  }

  return (
    <div>
      <h5>Run manifest actor</h5>
      <div className={FlexBox.FLEX}>
        <div className={FlexGrow.GROW_1}>
          <Select
            tether={true}
            label="Actor"
            searchable={false}
            clearable={false}
            options={manifestActors}
            onChange={option => setActorName(option)}
            value={actorName}
          />
        </div>
        <div>
          <Button
            type={'primary'}
            style={{ height: '50px', marginLeft: '10px' }}
            onClick={() => submitManifestSingleActor()}
            disabled={actorName === null || actorName === undefined}
          >
            Run actor
          </Button>
        </div>
      </div>
    </div>
  );
}
